import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Grid, Snackbar, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import client from '../api/client';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

export default function CatalogPage() {
  const [items, setItems] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [snackOpen, setSnackOpen] = useState(false);
  const [addedItems, setAddedItems] = useState(new Set());
  const { addItem } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    client.get('/catalog').then(r => setItems(r.data)).catch(console.error);
  }, []);

  function handleAdd(item) {
    const qty = parseInt(quantities[item.itemId], 10);
    if (qty > 0) {
      addItem(item, qty);
      setQuantities(q => ({ ...q, [item.itemId]: '' }));
      setSnackOpen(true);
      setAddedItems(s => new Set(s).add(item.itemId));
      setTimeout(() => {
        setAddedItems(s => {
          const next = new Set(s);
          next.delete(item.itemId);
          return next;
        });
      }, 1500);
    }
  }

  function handleQtyClick(itemId) {
    if (!quantities[itemId]) {
      setQuantities(q => ({ ...q, [itemId]: '1' }));
    }
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">{t('catalog.title')}</Typography>
        <Button variant="outlined" onClick={() => navigate('/cart')}>{t('catalog.cart')}</Button>
      </Box>
      <Grid container spacing={2}>
        {items.map(item => {
          const qtyValue = quantities[item.itemId] ?? '';
          const canAdd = parseInt(qtyValue, 10) > 0;
          return (
          <Grid item xs={12} sm={6} md={4} key={item.itemId}>
            <Card>
              <CardContent>
                <Typography variant="h6">{item.title}</Typography>
                <Typography color="text.secondary" gutterBottom>{item.type}</Typography>
                <Typography>{item.description}</Typography>
                <Typography sx={{ mt: 1 }}>{item.price} EUR</Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                  <TextField
                    label={t('catalog.qty')} type="number" size="small" sx={{ width: 70 }}
                    value={qtyValue}
                    placeholder="1"
                    onChange={e => setQuantities(q => ({ ...q, [item.itemId]: e.target.value }))}
                    onClick={() => handleQtyClick(item.itemId)}
                    inputProps={{ min: 1 }}
                  />
                  <Button
                    variant="contained"
                    color={addedItems.has(item.itemId) ? 'success' : 'primary'}
                    onClick={() => handleAdd(item)}
                    disabled={!canAdd}
                  >
                    {addedItems.has(item.itemId) ? t('catalog.added') : t('catalog.add')}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          );
        })}
      </Grid>
      <Snackbar
        open={snackOpen}
        autoHideDuration={2000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="success" onClose={() => setSnackOpen(false)}>{t('nav.cart')}</Alert>
      </Snackbar>
    </Box>
  );
}
